<agr-page-detail
  [pageTitle]="pageTitle$ | async"
  [isEmpty]="!(tableData$ | async)?.length"
  [emptyTitle]="'noTreatments' | translate"
  [emptyDescription]="'noTreatmentsInAdvice' | translate"
  [hasPrimaryAction]="true"
  primaryActionIcon="print"
  [primaryActionText]="'printReport' | translate"
  (primaryAction)="print()"
  (backAction)="back()"
  [buttonItems]="buttonItems$ | async"
  (buttonAction)="buttonAction($event)"
>
  <agr-print-page
    [footerText]="'gbmWarningFooter' | translate"
    [relatedPeople]="relatedPeople$ | async"
    [marginLeft]="true"
    [showPageNumber]="false"
  >
    <app-general-info></app-general-info>

    <div class="layout--margin-horizontal">
      <h4>{{ 'legend.title' | translate }}</h4>
      <p>{{ 'legend.explanation' | translate }}</p>
      <p>{{ 'legend.codesCaption' | translate }}:</p>
      <ol type="A">
        <li>{{ 'legend.codeA' | translate }}</li>
        <li>{{ 'legend.codeB' | translate }}</li>
        <li>{{ 'legend.codeC' | translate }}</li>
      </ol>
      <p>{{ 'legend.emptyField' | translate }}.</p>
    </div>

    <div class="spacing--margin-half-vertical">
      <app-environmental-impact-table
        [tableReportData$]="sortedTableData$"
      ></app-environmental-impact-table>
    </div>
  </agr-print-page>
</agr-page-detail>
